export const POPULAR_ANALYSIS_PARTNER_SLUG = 'kdl'
